import React, { useState, useEffect, useRef } from "react";
import MaterialTable from "material-table";
import "react-sliding-pane/dist/react-sliding-pane.css";
import ContentLoader from "react-content-loader";
import { ToastContainer,toast } from "react-toastify";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import { autoTable } from 'jspdf-autotable'
import _ from "lodash";

import ViewPaymentService from "../../../../services/contract/paymentSchedule/paymentdetailsViewService";
import Helper from "../../../../Helper";
import { getTrans as t } from "../../../../Localization/translations";

function PaymentDetailsEditQuote({
  id,
  refresh,
  terminationdate,
  transactiondate,
}) {
  const paymentdetailref = useRef();
  const [selectedRows, setSelectedRows] = useState([]);
  
  const [selectedDate, setSelectedDate] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPDRowTableId, setSelectedPDRowID] = useState("");
  let lastSelectedRow = null;
  
  useEffect(() => {
    if (refresh === true) {
      handelDefault();
    }
  }, [refresh]);

  useEffect(() => {
    if (items) {
      const defaultSelectedRows = items
        .filter((item) => item.enddate <= terminationdate)
        .map((item) => item.tableData.id);
      setSelectedRows(defaultSelectedRows);
    }
  }, [terminationdate, items]);

  const handelDefault = () => {
    ViewPaymentService.getPaymentDetails(id).then((response) => {
      setItems(response.data);
    })
  };

  useEffect(() => {
    setLoading(false);
    handelDefault();
  }, []);


  return (
    <>
      {loading === false ? (
        <div className="page-wrapper">
          <ToastContainer />
          <div className="">
            <div className="row show_contract show_invoice">
              <div className="ms-auto my-auto mt-lg-0 mt-4">
                <div className="ms-auto my-auto"></div>
                <div className="">
                  <div className="row"></div>
                </div>
              </div>
              <div className="">
                <div className="col-md-12 ">
                  <div className="">
                    <div className="body">
                      <div className=" p-0">
                        <MaterialTable
                          tableRef={paymentdetailref}
                          style={{
                            backgroundColor: "var(--bs-table-bg)",
                            borderBottomWidth: "1px",
                            boxShadow:
                              "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                          }}
                          title={
                            <h5 className="mb-0">{t("Payment Details")}</h5>
                          }
                          columns={[
                            {
                              title: `${t("Payment Date")}`,
                              field: "paymentdate",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Payment Date")}
                                  </div>
                                  <div>
                                    {Helper.DateNormal(rowData.paymentdate)}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Payment Type")}`,
                              field: "paymenttype",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Payment Type")}
                                  </div>
                                  <div>{rowData.paymenttype}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Start Date")}`,
                              field: "startdate",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Start Date")}
                                  </div>
                                  <div>
                                    {Helper.DateNormal(rowData.startdate)}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("End Date")}`,
                              field: "enddate",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("End Date")}
                                  </div>
                                  <div>
                                    {Helper.DateNormal(rowData.enddate)}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Amount")}`,
                              field: "periodicamount",
                              render: (rowData) => (
                                <>
                                  <div  className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
>
                                    {t("Amount")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}> 
                                    {Helper.Amount(rowData.periodicamount)}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Paid Amount")}`,
                              field: "periodicamount",
                              render: (rowData) => (
                                <>
                                  <div  className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
>
                                    {t("Paid Amount")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                    {rowData.amount
                                      ? Helper.Amount(rowData.amount)
                                      : ""}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Date Billed")}`,
                              field: "date_billed",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Date Billed")}
                                  </div>
                                  <div>
                                    {rowData.date_billed
                                      ? Helper.DateNormal(rowData.date_billed)
                                      : "None"}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                          ]}
                          data={items}
                          localization={{
                            toolbar: {
                              searchPlaceholder: "Search Paymentdetail",
                            },
                          }}
                          options={{
                            headerStyle: {
                              backgroundColor: "white",
                              color: "#245C7F",
                              fontSize: 11,
                            },
                            rowStyle: (rowData) => ({
                              backgroundColor: selectedRows.includes(
                                rowData.tableData.id
                              )
                                ? "#68BBE3"
                                : "#fff",
                            }),

                            sorting: true,
                            search: false,
                            toolbar: true,
                            paging: true,
                            pageSize: 10, // make initial page size
                            emptyRowsWhenPaging: false, // To avoid of having empty rows
                            pageSizeOptions: [10, 20, 25, 50, 100, 200],
                            paginationType: "stepped",
                            showFirstLastPageButtons: false,
                            exportAllData: false,
                            exportButton: false,
                            showSelectAllCheckbox: false,

                            exportFileName: "Payment Detail",
                            exportPdf: (data, columns) => {
                              const doc = new jsPDF();
                              const columnTitles = data.map(
                                (columnDef) => columnDef.title
                              );

                              const pdfData = columns.map((rowData) =>
                                data.map(
                                  (columnDef) => rowData[columnDef.field]
                                )
                              );
                              // doc.autoTable({
                              autoTable(doc,{
                                head: [columnTitles],
                                body: pdfData,
                              });

                              doc.save(`contract.pdf`);
                            },
                            actionsColumnIndex: -1,

                            selection: true,
                            showTextRowsSelected: false,
                            selectionProps: (rowData) => ({
                              onChange: () => {
                                // Only consider the last selected row
                                paymentdetailref.current.onAllSelected(false);
                                rowData.tableData.checked = true;
                                setSelectedPDRowID(rowData.tableData.id);

                                lastSelectedRow = rowData;

                                // If the row is already selected, deselect it
                                const isRowSelected = selectedRows.includes(
                                  lastSelectedRow.tableData.id
                                );

                                if (isRowSelected) {
                                  // Deselect the row
                                  const newSelectedRows = selectedRows.filter(
                                    (rowId) =>
                                      rowId !== lastSelectedRow.tableData.id
                                  );
                                  setSelectedRows(newSelectedRows);
                                  const selectedDate =
                                    items[lastSelectedRow.tableData.id].enddate;
                                  // Clear the date when nothing is selected
                                  setSelectedDate(selectedDate);
                                  transactiondate(selectedDate);
                                } else {
                                  const newSelectedRows = Array.from(
                                    {
                                      length: lastSelectedRow.tableData.id + 0,
                                    },
                                    (_, index) => index
                                  );
                                  setSelectedRows(newSelectedRows);

                                  // Get the date of the last row in the selection
                                  const selectedDate =
                                    items[lastSelectedRow.tableData.id].enddate;

                                  setSelectedDate(selectedDate);
                                  transactiondate(selectedDate);
                                }
                              },
                            }),
                          }}
                          onSelectionChange={(rows) => {
                            if (rows.length > 0) {
                              // Only consider the last selected row
                              rows.forEach((obj) => {
                                if (obj.tableData.id === selectedPDRowTableId) {
                                  obj.tableData.checked = true;
                                } else {
                                  obj.tableData.checked = false;
                                }
                              });

                              lastSelectedRow = rows[rows.length - 1];

                              // If the row is already selected, deselect it
                              const isRowSelected = selectedRows.includes(
                                lastSelectedRow.tableData.id
                              );

                              if (isRowSelected) {
                                // Deselect the row
                                const newSelectedRows = selectedRows.filter(
                                  (rowId) =>
                                    rowId !== lastSelectedRow.tableData.id
                                );
                                setSelectedRows(newSelectedRows);
                                const selectedDate =
                                  items[lastSelectedRow.tableData.id].enddate;
                                // Clear the date when nothing is selected
                                setSelectedDate(selectedDate);
                                transactiondate(selectedDate);
                              } else {
                                // Create a new array with all rows above the last selected row
                                const newSelectedRows = Array.from(
                                  { length: lastSelectedRow.tableData.id + 1 },
                                  (_, index) => index
                                );
                                setSelectedRows(newSelectedRows);

                                // Get the date of the last row in the selection
                                const selectedDate =
                                  items[lastSelectedRow.tableData.id].enddate;

                                setSelectedDate(selectedDate);
                                transactiondate(selectedDate);
                              }
                            } else {
                              // If no rows are selected, clear the selection
                              setSelectedRows([]);
                              setSelectedDate(null);
                              transactiondate(null);
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <ContentLoader
          viewBox="0 0 1000 550"
          backgroundColor="rgba(0,0,0,0.06)"
          foregroundColor="rgba(0,0,0,0.12)"
        >
          <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
          <circle cx="879" cy="123" r="11" />
          <circle cx="914" cy="123" r="11" />
          <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
          <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
          <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
          <circle cx="880" cy="184" r="11" />
          <circle cx="915" cy="184" r="11" />
          <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
          <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
          <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
          <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="242" r="11" />
          <circle cx="916" cy="242" r="11" />
          <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="303" r="11" />
          <circle cx="917" cy="303" r="11" />
          <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
          <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="363" r="11" />
          <circle cx="916" cy="363" r="11" />
          <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="424" r="11" />
          <circle cx="917" cy="424" r="11" />
          <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
          <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
          <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
          <circle cx="882" cy="484" r="11" />
          <circle cx="917" cy="484" r="11" />
          <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
          <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
          <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
          <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
          <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
          <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
          <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
        </ContentLoader>
      )}
    </>
  );
}

export default PaymentDetailsEditQuote;
